import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// Import translation files
import en from '@/locales/en.json'
import es from '@/locales/es.json'
import pt from '@/locales/pt.json'

// Create i18n instance
const i18n = new VueI18n({
  locale: 'en', // default locale
  fallbackLocale: 'en',
  messages: {
    en,
    es,
    pt
  },
  silentTranslationWarn: true // Prevent console warnings for missing keys in dev
})

/**
 * Map backend language codes to i18n locale codes
 * Backend uses: ENG, SPA, POR
 * i18n uses: en, es, pt
 */
export const languageCodeMap = {
  ENG: 'en',
  SPA: 'es',
  POR: 'pt',
  // Reverse mappings for convenience
  en: 'ENG',
  es: 'SPA',
  pt: 'POR'
}

/**
 * Get locale code from backend language code
 * @param {string} backendCode - Backend language code (e.g., 'ENG', 'SPA', 'POR')
 * @returns {string} - i18n locale code (e.g., 'en', 'es', 'pt')
 */
export function getLocaleFromBackendCode (backendCode) {
  return languageCodeMap[backendCode] || 'en'
}

/**
 * Get backend code from locale code
 * @param {string} locale - i18n locale code (e.g., 'en', 'es', 'pt')
 * @returns {string} - Backend language code (e.g., 'ENG', 'SPA', 'POR')
 */
export function getBackendCodeFromLocale (locale) {
  return languageCodeMap[locale] || 'ENG'
}

/**
 * Get language display name
 * @param {string} locale - i18n locale code
 * @returns {string} - Display name
 */
export function getLanguageDisplayName (locale) {
  const names = {
    en: 'English',
    es: 'Español',
    pt: 'Português'
  }
  return names[locale] || locale
}

export default i18n

